export * from './baMsgCenter.component';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/components/baMsgCenter/index.ts